import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private http = inject(HttpClient);


  private config: any;

async load(): Promise<void> {
    const configPath = 'config.json';

    try {
      this.config = await firstValueFrom(this.http.get(configPath));
      console.log('Config loaded:', this.config);
    } catch (err) {
      console.error('Failed to load config.json', err);
      throw err;
    }
  }

  getUrlFor(name: string): string | undefined {
    return this.config?.instances?.find((instance: any) => instance.instance.toUpperCase() === name.toUpperCase())?.url;
  }

  getBEUrlFor(name: string): string | undefined {
    return this.config?.instances?.find((instance: any) => instance.instance.toUpperCase() === name.toUpperCase())?.beURL;
  }

  getBgIdFor(name: string): number[] | undefined {
    return this.config?.instances?.find((instance: any) => instance.instance.toUpperCase() === name.toUpperCase())?.BgId;
  }

  getBuIdFor(name: string): number | undefined {
    return this.config?.instances?.find((instance: any) => instance.instance.toUpperCase() === name.toUpperCase())?.businessUnitId;
  }

  // getAvailableInstances(): string[] {
  //   return this.config?.instances?.map((instance: any) => instance.instance) || [];
  // }
}
